import { connect } from 'react-redux';
import QRCodeTab from './QRCodeTab';
import {
  modalPostStockOpen,
  modalPostStockConsignmentOpen,
  modalShipmentSubmergeOpen,
  modalShipmentRedeemConsignmentOpen,
  modalStatusClear,
  modalProcessingStartOpen,
  modalDeletingPieceOpen
} from '../../store/actions/modal';
import { qrDataList } from '../../store/actions/qr';

import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  qrReducer,
  modalReducer,
  userReducer,
  incomingReducer,
  shipmentReducer,
  popupActReducer,
  tabsReducer,
  processingReducer,
  settingsReducer
}) => ({
  qrReducer,
  modalReducer,
  userReducer,
  incomingReducer,
  shipmentReducer,
  popupActReducer,
  tabsReducer,
  processingReducer,
  settingsReducer
});
const mapDispatchToProps = {
  modalPostStockOpen,
  modalPostStockConsignmentOpen,
  modalShipmentSubmergeOpen,
  qrDataList,
  modalStatusClear,
  modalShipmentRedeemConsignmentOpen,
  modalErrorOpen,
  modalProcessingStartOpen,
  modalDeletingPieceOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QRCodeTab);
